import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { MatchBetsReportLayer } from "../components/Report/MatchBetsReportLayer";

export const MatchBetsReportPage = () => (
  <MasterLayout>
    <MatchBetsReportLayer />
  </MasterLayout>
);
